export * from "./date"
export * from "./formatter"
export * from "./xhr"
export * from "./toast"
export * from "./text"
export * from "./drag_enabled"
export * from "./icons"
export * from "./print_element"
export * from "./badges"
import { toast } from "./toast"
import { xhr } from "./xhr"
// @ts-ignore
import userPng from "$app/images/users/default.jpg"

export function sortElementsForSortable(
  elements: any[],
  newIndex: number,
  oldIndex: number
): any[] {
  let newElements = [...elements]
  const tmpElement = newElements[oldIndex]

  if (newIndex > oldIndex) {
    newElements.splice(oldIndex, 1)
    return [
      ...newElements.slice(0, newIndex),
      tmpElement,
      ...elements.slice(newIndex + 1, elements.length + 1)
    ].filter((g) => !!g)
  } else {
    newElements.splice(oldIndex, 1)
    return [
      ...elements.slice(0, newIndex),
      tmpElement,
      ...newElements.slice(newIndex, elements.length + 1)
    ].filter((g) => !!g)
  }
}

export function getVideoThumb(
  url: string,
  source: "youtube" | "vimeo" | string
): string {
  let thumb = ""
  if (source === "youtube") {
    const resp = url.match(/youtube.com.*(?:\/|v=)([^&$\?]+)/)
    thumb = `https://img.youtube.com/vi/${resp[1]}/hqdefault.jpg`
  } else if (source === "vimeo") {
    const resp = url.match(
      /https?:\/\/(?:[\w]+\.)*vimeo\.com(?:[\/\w]*\/?)?\/(?<id>[0-9]+)[^\s]*/
    )

    thumb = `https://vumbnail.com/${resp[1]}.jpg`
  } else {
    thumb = ""
  }

  return thumb
}

export async function resumeOnboarding(plan_id: number): Promise<void> {
  try {
    await xhr.patch(`/plan_onboarding/${plan_id}/skip_onboarding.json`, {
      skip_onboarding: false
    })
    window.location.href = `/plan_onboarding/${plan_id}`
  } catch (e) {
    console.error(e)
    toast("There was an error resuming onboarding", "error")
  }
}

export async function cancelOnboarding(plan_id: number): Promise<void> {
  try {
    await xhr.patch(`/plan_onboarding/${plan_id}/cancel.json`, {})
    window.location.href = `/plans/${plan_id}`
  } catch (e) {
    console.error(e)
    toast("There was an error canceling onboarding", "error")
  }
}

export const debounce = (callback: Function, wait: number) => {
  let timeoutId: any = null
  return (...args) => {
    window.clearTimeout(timeoutId)
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args)
    }, wait)
  }
}

export function getAvatar(user_id: number, avatars: AvatarType[]): string {
  try {
    const avatar = avatars.find((a) => a.user_id === user_id)
    return avatar ? avatar.avatar_url : userPng
  } catch (e) {
    return userPng
  }
}

function parseVimeoUrl(url: string): { a: string; b: string | null } | null {
  const match = url.match(
    /^https:\/\/vimeo\.com\/(\d+)(?:\/([a-zA-Z0-9]+))?(?:[?#].*)?$/
  )
  if (!match) return null
  return {
    a: match[1],
    b: match[2] ?? null
  }
}

/**
 * Handles click events on video links to open them in a modal
 * @param event MouseEvent
 * @returns void
 */
export function handleVideoLinkClick(event: MouseEvent): void {
  let el = event.target as HTMLElement

  if (el.parentElement?.tagName === "A") {
    el = el.parentElement
  }

  let isLink = el.tagName === "A" && !!el.getAttribute("href")
  if (!isLink) return

  let href = el.getAttribute("href")

  if (!href) return

  if (href.match(/youtube\.com/) || href.match(/vimeo\.com/)) {
    event.preventDefault()

    let iframeSrc = ""
    if (href.match(/youtube\.com/)) {
      iframeSrc = href.replace("watch?v=", "embed/")
    } else if (href.match(/vimeo\.com/)) {
      const { a, b } = parseVimeoUrl(href) || {}
      if (!a) return

      let vid = href
        .replace("vimeo.com", "player.vimeo.com/video")
        .replace("?share=copy", "")
      if (b) {
        vid = vid.replace(`\/${b}`, "") + "?h=" + b + "&badge=0"
      } else {
        vid = vid + "?badge=0"
      }

      iframeSrc = vid
    }

    const dialog: HTMLDialogElement = document.querySelector("#video-dialog")
    if (!dialog) return

    const iframe = dialog.querySelector("iframe")
    if (!iframe) return

    iframe.setAttribute("src", iframeSrc)

    dialog.showModal()
  }
}
